import { AxiosInstance } from "axios";

export default class BaseAPI {
  axios: AxiosInstance;
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }
}
